// Reunderwriting Module (Tier 3) PR 3 — feature-flag gate that mirrors
// the backend [FeatureFlag("reunderwriting-v1")] resource filter. When
// the flag is off the backend returns 404 for every /api/reunderwriting/*
// route; the frontend hides the nav entry + renders nothing on the
// pipeline route so a deep-bookmark lands on the standard not-found page
// instead of an empty-data screen.
//
// Reads VITE_FEATURE_REUNDERWRITING_V1; unset → defaults to true so
// local-dev (which doesn't define the var) behaves like staging.
//
// PreContributionScope (2026-06) — the platform is scoped to the
// pre-contribution period, which has no reunderwriting workflow. While
// that scope flag is ON (its default), this hook reports the module as
// off regardless of VITE_FEATURE_REUNDERWRITING_V1, which hides every
// consumer at once: the LoanHeader "Send to reunderwriting" CTA, the
// sidebar Reunderwriting group, and the /reunderwriting/* route pages
// (each renders its existing "disabled" notice on a deep link).

import { useFeatureFlag } from "@/hooks/portfolioAdmin/useFeatureFlag";

const REUNDERWRITING_V1_ENV = "VITE_FEATURE_REUNDERWRITING_V1";

function readBool(name: string, defaultValue: boolean): boolean {
  const raw = (import.meta.env as Record<string, string | undefined>)[name];
  if (raw === undefined || raw === "") return defaultValue;
  return raw.toLowerCase() === "true" || raw === "1";
}

export function useReunderwritingV1(): boolean {
  const preContributionScope = useFeatureFlag("PreContributionScope");
  return !preContributionScope && readBool(REUNDERWRITING_V1_ENV, true);
}
